// Design tokens for SpedineStudio.
// The palette is pulled from the studio's own assets: the plum-grey backdrop and
// dusty rose of the logo, and the fuchsia of the blazer in the portrait.
// Fuchsia is reserved for actions — never decoration.

export const color = {
  ink: '#201a1e',      // plum-black — dark bands, headings
  inkSoft: '#332a2f',  // raised surfaces on dark
  text: '#4a4046',     // body copy on light
  textMute: '#766b70', // captions, notes
  line: '#e4d8da',     // hairlines on porcelain
  lineDark: '#4a3f44', // hairlines on ink
  porcelain: '#f7f2f2', // page background
  white: '#ffffff',
  rose: '#d9959e',     // logo accent — decorative only
  roseSoft: '#f0dcde',
  fuchsia: '#b8256b',  // action
  fuchsiaDark: '#921c55',
};

export const font = {
  display: "'Fraunces', Georgia, serif",
  body: "'Jost', 'Helvetica Neue', Arial, sans-serif",
};

// Fraunces variable axes. Low weight + soft terminals + wonk keeps the display
// face close in feel to the script logo without imitating it.
export const displaySoft = `
  font-family: ${font.display};
  font-variation-settings: 'SOFT' 60, 'WONK' 1;
  font-weight: 300;
  letter-spacing: -0.01em;
`;

// Tracked-out caps for eyebrows and labels.
export const label = `
  font-family: ${font.body};
  font-size: 11px;
  font-weight: 500;
  letter-spacing: 0.22em;
  text-transform: uppercase;
`;

// The nail-tip arch — the page's signature form. Rounded crown, square base.
export const arch = 'border-radius: 999px 999px 6px 6px';

export const space = {
  section: 'clamp(72px, 11vw, 132px)',
  gutter: 'clamp(20px, 5vw, 40px)',
};

export const maxWidth = '1120px';

export const bp = {
  sm: '@media (min-width: 600px)',
  md: '@media (min-width: 860px)',
  lg: '@media (min-width: 1100px)',
};

export const ease = 'cubic-bezier(0.22, 1, 0.36, 1)';
